export default {
  heading: {
    widgetName: "As-Low-As-RM10",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Cook a delicious feast for the family from as low as RM10",
    headlineType: 'h2',
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer Value Pack`,
      eventLabelCardClick: `Grocer Value Pack | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer Value Pack | headline | {{headline}}`,
      eventLabelView: `Grocer Value Pack`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/CRS_chong-e-essential.jpg",
      title: "Cooking Kit Starter Value Pack",
      subtitle: "Get this great starter pack for all your kitchen adventures, choose four (4) items from the selections.",
      star: "",
      originalprice: "",
      price: "10",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/combo/airasia-grocer-value-pack/cooking-kit-starter-value-pack",
      currencyCode: "MYR",
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/CRS_chong-e-seafood.jpg",
      title: "Seafood Prosperity Value Pack",
      subtitle: "Choose a total of 6 seafoods from the selections",
      star: "",
      originalprice: "56",
      price: "50",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/combo/airasia-grocer-value-pack/seafood-prosperity-value-pack",
      currencyCode: "MYR",
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/CRS_chong-e-chicken.jpg",
      title: "Chicken Bonanza Value Pack",
      subtitle: "Pick the freshest chicken cuts",
      star: "",
      originalprice: "41",
      price: "35",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/combo/airasia-grocer-value-pack/chicken-bonanza-value-pack",
      currencyCode: "MYR",
    }
  ],
}
